import React, { FC } from 'react';

interface PreloaderProps {
  isShowing: boolean;
  Text: string
}

const SpinnerIcon = () => (
  <svg 
    className="animate-spin h-12 w-12 text-primary dark:text-dark-primary" 
    xmlns="http://www.w3.org/2000/svg" 
    fill="none" 
    viewBox="0 0 24 24"
  >
    <circle 
      className="opacity-25" 
      cx="12" 
      cy="12" 
      r="10" 
      stroke="currentColor" 
      strokeWidth="4"
    ></circle>
    <path 
      className="opacity-75" 
      fill="currentColor" 
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    ></path>
  </svg>
);

const Preloader: FC<PreloaderProps> = ({ isShowing, Text }) => {
  if (!isShowing) return null;  

  return (
    <div className="min-h-screen bg-background dark:bg-dark-background flex flex-col items-center justify-center transition-colors duration-300">
      <SpinnerIcon />
      <p className="mt-4 text-lg font-medium text-on-surface-variant dark:text-dark-on-surface-variant">      
        {Text}
      </p>
    </div>
  );
};

export default Preloader;
